import { InjectionToken } from '@angular/core';

export interface LoggingEnvironmentConfig {
  production: boolean;
  version?: string;
}

export const LoggingEnvironment: InjectionToken<LoggingEnvironmentConfig> = new InjectionToken<
  LoggingEnvironmentConfig
>('LoggingEnvironment');
